<template>
  <div class="admin_menu">
    <div class="logo" @click="returnBack">
      <img src="../assets/images/white_logo.png" />
    </div>
    <!--註冊--role是manager, 才能顯示 nav-->
    <nav v-if="$store.state.user.isPass == 2">
      <template v-for="(item, index) in menu">
        <div class="menu" :key="index" @click="menuGo(item)" :class="isMenu === item.val ? 'check' : ''">
          <i :class="item.icon"></i>
          {{ item.name }}
        </div>
        <!--MyTransition 是全域元件 不用再import & 註冊-->
        <MyTransition :myName="'up'" :key="item.val">
          <div class="sub_menu" v-if="item.child && subMenu">
            <div v-for="(sub, i) in item.child" :key="i" @click="menuGo(sub, item)"
              :class="isSubMenu === sub.val ? 'check' : ''">
              <i :class="sub.icon"></i>
              {{ sub.name }}
            </div>
          </div>
        </MyTransition>
      </template>
    </nav>
  </div>
</template>
<style lang="scss">
.admin_menu {
  padding: 20px 0;
  height: 100%;
  position: relative;
  background: var(--mainColor);

  .logo {
    cursor: pointer;
    max-width: 50%;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }

  nav {
    padding: 40px 0px;
    background: var(--mainColor);
    text-align: left;

    >.menu {
      cursor: pointer;
      padding: 12px 0;
      font-size: 14px;
      color: #b4b6ff;

      &:hover {
        font-weight: bold;
        // color: var(--mainColorHover);
        color: #fff;
        background: var(--mainColor2);

        i {
          color: #fff;
        }
      }

      &.check {
        font-weight: bold;
        color: #fff;
        background: var(--mainColor2);

        i {
          color: #fff;
        }
      }
    }

    .sub_menu {
      margin-top: 20px;
      background: #471aba;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      padding: 10px 0;
      font-size: 13px;
      margin: 0 10px;
      color: #b4b6ff;

      >div {
        cursor: pointer;
        padding: 0px 10px 10px 10px;

        &:hover {
          color: #fff;
          font-weight: bold;
        }

        &.check {
          color: #fff;
          font-weight: bold;
        }
      }
    }

    i {
      color: #b4b6ff;
      font-size: 17px;
      padding: 0 15px;
    }
  }
}
</style>
<script>
export default {
  name: "adminMenu",
  props: {
    page: "",
  },
  data() {
    return {
      raw_menu: [
        {
          name: "承攬商列表",
          val: "contractor_list",
          icon: "el-icon-document",
          page: ["admin", "department"],
          role: ["manager", "department"],
        },
        {
          name: "新增承攬商",
          val: "add_contractor",
          icon: "el-icon-document-add",
          page: ["admin"],
          role: ["manager"],
        },
        {
          name: "員工資料管理",
          val: "employee",
          icon: "el-icon-user",
          page: ["contractor"],
          role: ["manager", "vendor"],
        },
        {
          name: "(原)工程單",
          val: "engineering",
          icon: "el-icon-truck",
          page: ["admin"],
          role: ["manager"], //2024/4/8改成只有manager有權限
        },
        {
          name: "(原)施工單",
          val: "construction",
          icon: "el-icon-truck",
          page: ["admin"],
          role: ["manager"],//2024/4/8改成只有manager有權限
        },
        {
          name: "施工單",
          val: "new_construction",
          icon: "el-icon-truck",
          page: ["admin", "department", "contractor"],
          role: ["manager", "vendor", "department"],
        },
        {
          name: "未結案施工單",
          val: "new_construction_finished",
          icon: "el-icon-finished",
          page: ["admin", "department"],
          role: ["manager", "department"],
        },
        // {
        //   name: "施工單",
        //   val: "construction",
        //   icon: "el-icon-truck",
        //   page: ["admin", "department", "contractor"],
        //   role: ["manager", "vendor", "department"],
        // },
        // {
        //   name: "NEW施工單",
        //   val: "new_construction",
        //   icon: "el-icon-truck",
        //   page: ["admin", "department"],
        //   role: ["manager","department"],
        // },
        {
          name: "緊急施工單",
          val: "urgent",
          icon: "el-icon-warning-outline",
          page: ["admin", "department"],
          role: ["manager", "department"],
        },
        {
          name: "原事業單位施工單",
          val: "enterprise",
          icon: "el-icon-s-cooperation",
          page: ["admin", "department"],
          role: ["manager", "vendor", "department"],
        },
        {
          name: "教材和試題",
          val: "course",
          icon: "el-icon-collection",
          page: ["admin"],
          role: ["manager"],
        },
        {
          name: "教材和試題",
          val: "test",
          icon: "el-icon-collection",
          page: ["contractor"],
          role: ["manager", "vendor"],
        },
        {
          name: "公司設定",
          icon: "el-icon-setting",
          val: "setting",
          page: ["contractor"],
          role: ["manager", "vendor"],
          child: [
            {
              name: "資料設定",
              val: "registered",
              icon: "el-icon-edit",
            },
            {
              name: "修改密碼",
              val: "password",
              icon: "el-icon-lock",
            },
          ],
        },
        // {
        //   name: "主管維護",
        //   val: "department_maintain_boss",
        //   icon: "el-icon-suitcase-1",
        //   page: ["department"],
        //   role: ["manager", "department"],
        // },
        // {
        //   name: "施工單(old)",
        //   val: "construction_",
        //   icon: "el-icon-truck",
        //   page: ["admin"],
        //   role: ["manager"],
        // },
        // {
        //   name: "新工程及施工單列表",
        //   val: "newconstruction",
        //   icon: "el-icon-truck",
        //   page: ["admin"],
        //   role: ["manager"],
        // },
        // {
        //   name: "工程、施工單管理",
        //   val: "de_construction",
        //   icon: "el-icon-truck",
        //   page: ["department"],
        //   role: ["manager", "department"],
        // },
        {
          name: "督導紀錄",
          icon: "el-icon-magic-stick",
          val: "safety-sheet",
          page: ["admin"],
          role: ["manager"],
        },
        {
          name: "清潔保全協議組織及合約",
          icon: "el-icon-magic-stick",
          val: "guard-sheet",
          page: ["admin"],
          role: ["manager"],
        },
        {
          name: "上傳施工單紙本",
          icon: "el-icon-magic-stick",
          val: "sheet",
          page: ["admin"],
          role: ["manager"],
        },

        {
          name: "維護",
          icon: "el-icon-setting",
          val: "setting",
          page: ["department"],
          role: ["manager", "department"],
          child: [
            {
              name: "修改密碼",
              val: "department_password",
              icon: "el-icon-lock",
            },
            //部門人員維護的權限統一由工安管理: 2023/9/11 meeting 需求
            // {
            //   name: "部門人員維護",
            //   val: "department_maintain",
            //   icon: "el-icon-user-solid",
            // },
          ],
        },

        {
          name: "使用手冊及表單",
          val: "instruction",
          icon: "el-icon-info",
          page: ["contractor", "department"],
          role: ["manager", "vendor", "department"],
        },
        {
          name: "聯絡我們",
          val: "contact",
          icon: "el-icon-phone-outline",
          page: ["contractor"],
          role: ["manager", "vendor"],
        },
        {
          name: "維護",
          icon: "el-icon-setting",
          val: "setting",
          page: ["admin"],
          role: ["manager"],
          child: [
            {
              name: "公告維護",
              val: "notice",
              icon: "el-icon-guide",
            },
            {
              name: "文件維護",
              val: "paper",
              icon: "el-icon-document-copy",
            },
            {
              name: "使用手冊維護",
              val: "guard",
              icon: "el-icon-info",
            },
            {
              name: "部門人員維護",
              val: "department_maintain",
              icon: "el-icon-user-solid",
            },
            // {
            //   name: "部門主管維護",
            //   val: "department_maintain_boss",
            //   icon: "el-icon-suitcase-1",
            // },
            {
              name: "工作區域維護",
              val: "location",
              icon: "el-icon-location-information",
            },
          ],
        },
      ],
      subMenu: false,
      isMenu: null,
      isSubMenu: null,
    };
  },
  computed: {
    isPage() {
      return `/${this.$route.path.split("/")[1]}`;
    },
    menu() {
      return this.raw_menu.filter((el) => {
        if (
          el.page.includes(this.$route.path.split("/")[1]) &&
          el.role.includes(this.$store.state.user.role)
        ) {
          return el;
        }
      });
    },
    // menu() {
    //   let contractorMenu = [
    //     { name: "員工資料管理", val: "employee", icon: "el-icon-user" },
    //     // { name: "合格證資料檢核", val: "", icon: "el-icon-document-checked" },
    //     { name: "教材和試題", val: "test", icon: "el-icon-collection" },
    //     {
    //       name: "公司設定",
    //       icon: "el-icon-setting",
    //       val: "setting",
    //       child: [
    //         {
    //           name: "資料設定",
    //           val: "registered",
    //           icon: "el-icon-edit",
    //         },
    //         {
    //           name: "修改密碼",
    //           val: "password",
    //           icon: "el-icon-lock",
    //         },
    //       ],
    //     },
    //     { name: "使用手冊及表單", val: "instruction", icon: "el-icon-info" },
    //     {
    //       name: "聯絡我們",
    //       val: "contact",
    //       icon: "el-icon-phone-outline",
    //     },
    //   ];
    //   let adminMenu = [
    //     {
    //       name: "承攬商列表",
    //       val: "contractor_list",
    //       icon: "el-icon-document",
    //     },
    //     // { name: "待審承攬商", val: "review", icon: "el-icon-document-checked" },
    //     {
    //       name: "新增承攬商",
    //       val: "add_contractor",
    //       icon: "el-icon-document-add",
    //     },
    //     {
    //       name: "教材和試題",
    //       val: "course",
    //       icon: "el-icon-collection",
    //     },
    //     { name: "施工單", val: "construction", icon: "el-icon-truck" },

    //     {
    //       name: "維護",
    //       icon: "el-icon-setting",
    //       val: "setting",
    //       child: [
    //         {
    //           name: "公告維護",
    //           val: "notice",
    //           icon: "el-icon-guide",
    //         },
    //         {
    //           name: "文件維護",
    //           val: "paper",
    //           icon: "el-icon-document-copy",
    //         },
    //         {
    //           name: "使用手冊維護",
    //           val: "guard",
    //           icon: "el-icon-info",
    //         },
    //         {
    //           name: "信箱維護",
    //           val: "department_maintain",
    //           icon: "el-icon-suitcase-1",
    //         },
    //       ],
    //     },
    //   ];
    //   let departmentMenu = [
    //     {
    //       name: "承攬商列表",
    //       val: "contractor_list",
    //       icon: "el-icon-document",
    //     },
    //     {
    //       name: "信箱維護",
    //       val: "department_maintain",
    //       icon: "el-icon-suitcase-1",
    //     },
    //     {
    //       name: "修改密碼",
    //       val: "department_password",
    //       icon: "el-icon-lock",
    //     },
    //     { name: "使用手冊", val: "instruction", icon: "el-icon-info" },
    //   ];
    //   if (this.page == "contractor") {
    //     return contractorMenu;
    //   } else if (this.page == "admin") {
    //     return adminMenu;
    //   } else if (this.page == "department") {
    //     return departmentMenu;
    //   }
    // },
  },
  methods: {
    returnBack() {
      this.$router.push(this.isPage);
      this.isMenu = null;
      this.subMenu = false;
      this.isSubMenu = null;
    },
    menuGo(item, main) {
      //判斷是否有子目錄
      this.isSubMenu = null;
      if (item.child) {
        //有子目錄
        this.subMenu = !this.subMenu;
        this.isMenu = item.val;
      } else {
        //判斷是否為子目錄的項目
        if (main) {
          //有子目錄項目
          this.$router.push(`${this.isPage}/${item.val}`);
          this.isMenu = main.val;
          this.isSubMenu = item.val;
        } else {
          this.subMenu = false;

          this.$router.push(`${this.isPage}/${item.val}`);
          this.isMenu = item.val;
        }
      }
    },
  },
  mounted() {
    this.isMenu = this.isPage;
  },
};
</script>
